export default{
    init(){
        this.findCustomers();
    },

    findCustomers(){
        $('#find_customers_btn').click(async function() {
            if($('#last_order_select').val()=='ignore' &&  $('#total_spent_select').val() == 'ignore'){
                $('#customer_search_info').html('');
                $('#find_customers_btn').attr('disabled', true);
                return;
            }else{
                $('#find_customers_btn').removeAttr('disabled');
            }
            let data = {
                last_order: $('#last_order_select').val(),
                last_order_value: parseInt($('#last_order_value').val()),
                query_connector: $('#operator_select').val(),
                total_spent: $('#total_spent_select').val(),
                total_spent_value: $('#total_spent_value').val(),
            };
            let status;
            let response = await fetch('/email-department/find-customers', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(data),
            } ).then(response => {status = response.ok; return response;}).then(response => response.text());
            //console.log(response);
            if (status) {
                $('#customer_search_info').html(response);
                $('#customer_search_info').removeClass('d-none');
            }
        });
    },
    async findAllCustomers(){
        let status;
        let response = await fetch('/email-department/find-all-customers', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
        }).then(response => {status = response.ok; return response;}).then(response => response.json());

        if(status){
            $('#promo_customers_count').text(response.customers);
        }
    },
}
